/* eslint-ignore */
// @ts-nocheck
import styled from 'styled-components';
import { Modal } from 'react-bootstrap';
import { ReactComponent as ReceiptIc } from '~/assets/icons/receipt.svg';

export const StyledModal = styled(Modal)`
  .modal-dialog {
    @media (min-width: 640px) {
      max-width: 600px !important;
    }
    @media (max-width: 640px) {
      max-width: 90% !important;
    }
  }
`;

export const ModalOrganizationContainer = styled(Modal.Body)`
  background-color: #ffffff;
  border-radius: 8px;
  width: 100%;
  padding: 30px;
`;

export const ModalOrganizationHeader = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 2px;
`;

export const ModalOrganizationLeft = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;

export const ModalOrganizationModalTitle = styled.span`
  font-size: 18px;
  color: ${({ theme }) => theme.colors.secondaryText};
`;

export const ModalOrganizationCloseIcon = styled.span`
  font-size: 22px;
  color: #074f8c;
  cursor: pointer;
`;

export const ModalOrganizationContent = styled.span`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const ModalOrganizationSeparator = styled.div`
  width: 100%;
  height: 1px;
  background-color: #d6d6d6;
`;

export const ModalOrganizationItem = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-top: 15px;
`;

export const ModalOrganizationTitle = styled.span`
  font-size: 18px;
  color: #074f8c;
`;

export const ModalOrganizationIcon = styled.span`
  font-size: 18px;
  cursor: pointer;
  color: black;
`;

export const ItemIcon = styled.span`
  font-size: 22px;
  color: ${({ theme }) => theme.colors.secondaryText};
  margin-right: 15px;
`;

export const ReceiptIcon = styled(ReceiptIc)`
  height: 22px;
  width: 22px;
  margin-right: 15px;
  path,
  .a {
    fill: none;
  }
  path,
  .b {
    fill: ${({ theme }) => theme.colors.secondaryText};
  }
`;
